import { ManagerWithRepresentativeType } from "../../types/limited-company-creation/managerWithRepresentativeType";
import { initialIndividualState } from "../commonInitialState/individualInitialState";

export const managerWithRepresentativeInitalState: ManagerWithRepresentativeType = {
    person: "Personne physique",
    personDetails: initialIndividualState
}

export function managerListWithRepresentativeInitalState( length: number ): ManagerWithRepresentativeType[] {
    return new Array( length ).fill( null ).map( () => ({
        person: "Personne physique",
        personDetails: { ...initialIndividualState }
    }))
}